import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from '#components/checkbox/checkbox';
import styles from './multi-select-footer.module.css';

export interface MultiSelectFooterProps {
  isIndeterminate: boolean;
  isAllSelected: boolean;
  onToggleAll: () => void;
}

export function MultiSelectFooter({
  isIndeterminate,
  isAllSelected,
  onToggleAll,
}: MultiSelectFooterProps): ReactNode {
  return (
    <div className={styles.footer} data-testid="multi-select-footer-button">
      <Checkbox
        aria-hidden="true"
        className={styles.footerCheckbox}
        isIndeterminate={isIndeterminate}
        isSelected={isAllSelected}
        onChange={onToggleAll}
      >
        <FormattedMessage
          id={
            isAllSelected || isIndeterminate ? 'multi-select-clear-all' : 'multi-select-select-all'
          }
        />
      </Checkbox>
    </div>
  );
}
